// extracted by mini-css-extract-plugin
export default {"element":"DNuM30WV3LKU_ZZGPrxh","tiny":"n36N6PlKp1bzVCBHjSdC","small":"FVaszb95FHPSYIJOevPj"};